<template>
  <div class="color-picker horizontalLayout">
    <div class="horizontalLayout_title">
      字体粗细
    </div>
    <div
      class="flex horizontalLayout_desc"
      placement="bottom"
      :transfer="true"
    >
      <div>
        <el-radio
          v-model="fontWeight"
          label="1"
        >
          常规
        </el-radio>
        <!-- <el-radio v-model="fontWeight" label="2"> 加粗 </el-radio> -->
      </div>
    </div>
  </div>
</template>
<script>
import mixin from '@/view/weappTmp/core/lib/package/element-node-mixin.js'
export default {
  name: 'SpFontWeight',
  mixins: [mixin],
  props: {},
  data () {
    return {
      fontWeight: '1',
      name: 'fontWeight'
    }
  },

  methods: {}
}
</script>

<style scoped lang="scss">
@import '@/weappTmps/comps/index.scss';
</style>
